<template>
    <v-container>
        <form-toolbar :canEdit="canEdit" :userRoles="userRoles" :editMode="editMode"  :field="'backOffice'" :assignment="assignment" @cancel-button-clicked="switchEditMode(false)" @edit-button-clicked="switchEditMode(true)"/>
        <v-form :readonly="readOnly" class="assignment-form">
            <v-card class = "form-group-fields" elevation="6">
                <div class = "first-row">
                    <v-card v-if="this.config.backOffice?.steps?.find(step => step.value === 'contractorCompleted')" class="checkbox-wrapper" elevation="4">
                        <custom-checkbox
                            :readOnly="readOnly"
                            :label="'Ολοκλήρωση εργολάβου'"
                            :color="'green'"
                            change-back
                            :value="!!this.localBackOffice.contractorCompletedAt"
                            @check-value-change="(e) => onValueChange(e, 'contractorCompleted')"
                        />
                        <div v-if="this.localBackOffice.contractorCompletedBy" class="ml-2"> από <b>{{ this.localBackOffice.contractorCompletedBy.firstName }} {{ this.localBackOffice.contractorCompletedBy.lastName }} </b> στις {{ getGreekDate(this.localBackOffice.contractorCompletedAt) }}</div>
                    </v-card>
                    <v-card v-if="this.config.backOffice?.steps?.find(step => step.value === 'pendingIssuesChecked')" class="checkbox-wrapper" elevation="4">
                        <custom-checkbox
                            :readOnly="readOnly"
                            :label="'Έλεγχος Εκκρεμοτήτων Φακέλων Έργου'"
                            :color="'green'"
                            change-back
                            :value="!!this.localBackOffice.checkForPendingIssuesAt"
                            @check-value-change="(e) => onValueChange(e, 'pendingIssues')"
                        />
                        <div v-if="this.localBackOffice.checkForPendingIssuesBy" class="ml-2"> από <b>{{ this.localBackOffice.checkForPendingIssuesBy.firstName }} {{ this.localBackOffice.checkForPendingIssuesBy.lastName }} </b> στις {{ getGreekDate(this.localBackOffice.checkForPendingIssuesAt) }}</div>
                    </v-card>
                    <v-card v-if="this.config.backOffice?.steps?.find(step => step.value === 'fsmUploaded')" class="checkbox-wrapper" elevation="4">
                        <custom-checkbox
                            :readOnly="readOnly"
                            :label="'Ανέβασμα FSM'"
                            :color="'green'"
                            change-back
                            :value="!!this.localBackOffice.fsmUploadAt"
                            @check-value-change="(e) => onValueChange(e, 'fsmUpload')"
                        />
                        <div v-if="this.localBackOffice.fsmUploadBy" class="ml-2"> από <b>{{ this.localBackOffice.fsmUploadBy.firstName }} {{ this.localBackOffice.fsmUploadBy.lastName }} </b> στις {{ getGreekDate(this.localBackOffice.fsmUploadAt) }}</div>
                    </v-card>
                    <v-card v-if="this.config.backOffice?.steps?.find(step => step.value === 'ktpUploaded')" class="checkbox-wrapper" elevation="4">
                        <custom-checkbox
                            :readOnly="readOnly"
                            :label="'Ανέβασμα ΚΤΠ'"
                            :color="'green'"
                            change-back
                            :value="!!this.localBackOffice.ktpUploadAt"
                            @check-value-change="(e) => onValueChange(e, 'ktpUpload')"
                        />
                        <div v-if="this.localBackOffice.ktpUploadBy" class="ml-2"> από <b>{{ this.localBackOffice.ktpUploadBy.firstName }} {{ this.localBackOffice.ktpUploadBy.lastName }} </b> στις {{ getGreekDate(this.localBackOffice.ktpUploadAt) }}</div>
                    </v-card>
                    <v-card v-if="this.config.backOffice?.steps?.find(step => step.value === 'sapUploaded')" class="checkbox-wrapper" elevation="4">
                        <custom-checkbox
                            :readOnly="readOnly"
                            :label="'Ανέβασμα SAP'"
                            :color="'green'"
                            change-back
                            :value="!!this.localBackOffice.sapUploadAt"
                            @check-value-change="(e) => onValueChange(e, 'sapUpload')"
                        />
                        <div v-if="this.localBackOffice.sapUploadBy" class="ml-2"> από <b>{{ this.localBackOffice.sapUploadBy.firstName }} {{ this.localBackOffice.sapUploadBy.lastName }} </b> στις {{ getGreekDate(this.localBackOffice.sapUploadAt) }}</div>
                    </v-card>
                </div>
                <comments
                    ref="comments"
                    :comments="this.localBackOffice?.comments || {}"
                    :clearable="clearable"
                    :editMode="editMode"
                    :rules="editMode ? rules: []"
                    @new-comment="onNewComment"
                />
            </v-card>
            <div v-if="canEdit" class="submit-button-wrapper">
                <v-btn class="mx-2 white--text" :disabled="shouldDisableSubmit" :loading="loading" large color="black" @click="onSubmit">
                    ΥΠΟΒΟΛΗ
                </v-btn>
            </div>
        </v-form>
        <alert :show-alert="showAlert" :message="message" :type="type" />
    </v-container>
</template>

<script>
    import assignmentService from '@/services/assignment'
    import Alert from '@/components/Alert'
    import FormToolbar from '@/components/FormToolbar'
    import momentTimezone from 'moment-timezone'
    import CustomCheckbox from '@/components/CustomCheckBox'
    import Comments from '@/components/Comments'

    export default {
        name: 'ConstructionTab',
        components: { Alert, FormToolbar, CustomCheckbox, Comments },
        props: {
            assignment: {
                type: Object,
                required: true
            },
            currentUser: {
                type: Object,
                default: () => { return {} },
                required: true
            },
            canEdit: {
                type: Boolean,
                required: true
            }
        },
        watch: {
            assignment: {
                handler() {
                    this.resetForm()
                },
                deep: true
            }
        },
        computed: {
            userRoles() {
                return this.currentUser?.roles?.map(role => role.role) || []
            },
            shouldDisableSubmit() {
                return !this.editMode
            },
            config() {
                return this.$store.getters.getConfig || {}
            }
        },
        data: () => {
            return {
                localBackOffice: {
                    pendingIssuesChecked: false,
                    fsmUploaded: false,
                    ktpUploaded: false,
                    sapUploaded: false
                },
                showAlert: false,
                message: null,
                clearable: true,
                type: null,
                loading: false,
                mode: null,
                readOnly: false,
                editMode: false,
                rules: [
                    v => !!v || 'Το πεδίο είναι υποχρεωτικό'
                ],
                newComment: null
            }
        },
        created() {
            this.mode = this.$route.params.mode
            if (this.mode === 'edit') {
                this.readOnly = true
                this.clearable = false
            }
            this.assignmentId = this.$route.params.assignmentId
        },
        mounted() {
            this.resetForm()
        },
        methods: {
            onNewComment(e) {
                this.newComment = e
            },
            onValueChange(value, type) {
                switch (type) {
                case 'contractorCompleted': this.localBackOffice.contractorCompleted = value; break
                case 'pendingIssues': this.localBackOffice.pendingIssuesChecked = value; break
                case 'fsmUpload': this.localBackOffice.fsmUploaded = value; break
                case 'ktpUpload': this.localBackOffice.ktpUploaded = value; break
                case 'sapUpload': this.localBackOffice.sapUploaded = value; break
                }
            },
            tabSelect(tab) {
                this.selectedTab = tab
            },
            switchEditMode(editMode) {
                if (!this.canEdit) {
                    return
                }
                this.resetForm()
                if (editMode) {
                    this.readOnly = false
                    this.clearable = true
                    this.editMode = true
                } else {
                    this.readOnly = true
                    this.editMode = false
                    this.clearable = false
                }
            },
            resetForm() {
                this.localBackOffice = this.assignment.backOffice ? JSON.parse(JSON.stringify(this.assignment.backOffice)) : {}
                if (this.localBackOffice.checkForPendingIssuesAt) {
                    this.localBackOffice.pendingIssuesChecked = true
                }
                if (this.localBackOffice.fsmUploadAt) {
                    this.localBackOffice.fsmUploaded = true
                }
                if (this.localBackOffice.ktpUploadAt) {
                    this.localBackOffice.ktpUploaded = true
                }
                if (this.localBackOffice.sapUploadAt) {
                    this.localBackOffice.sapUpload = true
                }
                if (this.localBackOffice.contractorCompletedAt) {
                    this.localBackOffice.contractorCompleted = true
                }
            },
            getGreekDate(utcDate) {
                return momentTimezone(utcDate).utc().tz('Europe/Athens').format('YYYY-MM-DD HH:mm').toString()
            },
            setAlert(message, type) {
                this.showAlert = true
                this.message = message
                this.type = type
                setTimeout(() => { this.showAlert = false }, 7000)
            },
            async editAssignment() {
                this.loading = true
                this.localBackOffice.newComment = this.newComment
                assignmentService.updateAssignmentTab('backOffice', this.assignment.id, { backOffice: this.localBackOffice }).then((response) => {
                    this.loading = false
                    this.$refs['comments'].clear()
                    this.switchEditMode(false)
                    this.setAlert('Η ενημέρωση του Back Office ήταν επιτυχημένη', 'success')
                    this.$emit('assignment-refresh')
                }).catch((error) => {
                    this.setAlert(error?.response?.data?.message || 'Προέκυψε κάποιο σφάλμα. Παρακαλώ επικοινωνήστε με τον Διαχειριστή', 'error')
                    this.loading = false
                })
            },
            async onSubmit() {
                if (this.mode === 'edit') {
                    this.editAssignment()
                }
            }
        }

    }
</script>
<style scoped>
.first-row {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    justify-content: center;
    flex-direction: column;
}

.checkbox-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 10px;
    padding-left: 0.8rem;
    margin: 0.5rem;
}

.form-group-fields {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    padding: 0.5rem;
}

.submit-button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 2vh;
}

.field.completed-checkbox {
    font-weight: 800;
}

input {
    text-align: center !important;
}

.v-card {
    color: var(--cards-and-tables-text-color) !important;
    background: var(--cards-and-tables-color) !important;
}

.field.completed-checkbox {
    font-weight: 800;
}

.text-area-wrapper {
    width: 100%;
}

.material-selection {
    width: 100%;
}

.field.status {
    min-width: 270px;
    max-width: 20%;
}

.troubleshoot-area {
    width: 100%;
}
</style>
